import { render, staticRenderFns } from "./PrivacyProtocol.vue?vue&type=template&id=77e10421&"
import script from "./PrivacyProtocol.vue?vue&type=script&lang=js&"
export * from "./PrivacyProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyProtocol.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports